module.exports = __webpack_public_path__ + "928f132c19fcb21a1bd4ab3667f99524.woff2";